import React from 'react'
import { FormAutocomplete, FormInputText } from '../../../dsn-kernel'
import { useSelector } from 'react-redux'
import { ChoixType } from '../ChoixType'
import { useWatch } from 'react-hook-form'

export const CreationVariableContexteForm = ({ classes, useFormObj, toEdit }) => {
  const fonctions = useSelector(state => state.fonctionModule.fonctions)
  const uniqueTags = new Set()
  const variableContextes = useSelector(state => state.variableContexteModule.variableContextes)
  variableContextes.forEach(item => {
    item.tags.forEach(tag => {
      uniqueTags.add(tag)
    })
  })
  const uniqueTagsList = Array.from(uniqueTags)

  const type = useWatch({ control: useFormObj.control, name: 'type' })
  const reference = useWatch({ control: useFormObj.control, name: 'reference' })
  const referenceObj = useWatch({ control: useFormObj.control, name: 'referenceObj' })
  const refNom = referenceObj ? referenceObj.nom : reference ? reference : null
  const fonctionList =
    type && refNom
      ? fonctions.filter(item => item.type === type && item.reference === refNom)
      : type
      ? fonctions.filter(item => item.type === type)
      : fonctions
  if (toEdit && (toEdit.type !== type || toEdit.reference !== refNom)) {
    useFormObj.setValue('fonction', null)
  }

  return (
    <>
      <FormInputText
        label={'Nom'}
        name="nom"
        control={useFormObj.control}
        rules={{ required: true }}
        disabled={!!toEdit}
      />
      <ChoixType classes={classes} useFormObj={useFormObj} withValeurDefaut={false} />
      <FormAutocomplete
        label={'Tags'}
        name="tags"
        control={useFormObj.control}
        multiple
        options={uniqueTagsList}
        freeSolo
      />
      <FormInputText
        label={'Description'}
        name="description"
        control={useFormObj.control}
        rules={{ required: true }}
        multiline
        rows={4}
      />
      <FormAutocomplete
        label={'Fonction'}
        name={'fonction'}
        options={fonctionList}
        getOptionSelected={(option, value) => option.nom === value.nom}
        getOptionLabel={option => option.nom}
        control={useFormObj.control}
      />
    </>
  )
}
